export const topRoutes = {
  label: 'top',
  labelDisable: true,
  children: [
    {
      name: 'Home',
      active: true,
      icon: 'home',
      to: '/'
    }
  ]
};

export const listingsRoutes = {
  label: 'Listings',
  labelDisable: false,
  children: [
    {
      name: 'My listings',
      active: true,
      icon: 'list',
      to: '/my-listings'
    },
    {
      name: 'My bookmarks',
      active: true,
      icon: 'bookmark',
      to: '/my-bookmarks'
    }
  ]
};

export const toolsRoutes = {
  label: 'Tools',
  labelDisable: false,
  children: [
    {
      name: 'Land inspection',
      active: true,
      icon: 'mountain-sun',
      to: '/land-inspection'
    },
    {
      name: 'Land development',
      active: true,
      icon: 'map',
      to: '/land-development'
    },
    {
      name: 'Living Carbon Grant',
      active: true,
      icon: 'circle',
      to: '/living-carbon-grant'
    }
  ]
};

const routes = [topRoutes, listingsRoutes, toolsRoutes];

export default routes;
